var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5e5e5e;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,22.5,7.82,17.36a2,2,0,0,1-.59-1.43,2,2,0,0,1,2-2,2,2,0,0,1,1.43.59L12,15.82V6.38a2,2,0,0,1,1.74-2,1.87,1.87,0,0,1,1.51.56,1.83,1.83,0,0,1,.57,1.34V12l5,.72a1.91,1.91,0,0,1,1.64,1.89h0a17.18,17.18,0,0,1-1.82,7.71l-.09.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.23 11.04 4.36 13.91 1.5 11.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.36,
    y1: 6.27,
    x2: 4.36,
    y2: 13.91
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.32 4.36 8.18 1.5 11.04 4.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.18,
    y1: 9.14,
    x2: 8.18,
    y2: 1.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.029011af6f043d3295741681799536df.svg";
export { ForwardRef as ReactComponent };